import { Component, Input, OnInit } from "@angular/core";
import { CONSTANTS } from "app/constants";
import { DrawingWCPlayoffResponseDto } from "app/models";
import { DrawingsService, NotificationService } from "app/services";

@Component({
    selector: 'drawing-wc-playoff',
    templateUrl: './drawing-wc-playoff.component.html',
    styleUrls: ['./drawing-wc-playoff.component.scss'],
})
export class DrawingWCPlayOff implements OnInit {
    
    @Input()
    stage: number;
    
    stages: any[];

    const;

    matchDay1: number;

    drawingResult: DrawingWCPlayoffResponseDto;

    isLoading: boolean = false;

    constructor(private drawingService: DrawingsService, private notificationService: NotificationService) {
        this.const = CONSTANTS;
    }

    ngOnInit(): void {
        this.buildEuroStagesDictionary();
        this.loadData();
    } 

    getStageLabel(): string {
        return this.stages[this.stage];
    }

    doDraw() {
        this.drawingService.drawWcPlayoff(this.matchDay1, this.stage)
            .subscribe(result => {
                this.notificationService.showSuccess('Жеребьевка проведена!');
            }, error => {
                this.notificationService.showError('Ошибка жеребьевки');
            })
    }

    private loadData() {
        this.isLoading = true;

        this.drawingService.getWCPrePlayoffData(this.stage)
            .subscribe(result => {
                    this.drawingResult = result;
                    this.isLoading = false;
                }, 
                error =>  {
                    this.notificationService.showError('Не удалось загрузить данные.');
                    this.isLoading = false;
                }
            )
    }

    private buildEuroStagesDictionary() {
        this.stages = [];
        this.stages[CONSTANTS.euroCupStages.playoff8] = CONSTANTS.euroCupStagesNames.playoff8;
        this.stages[CONSTANTS.euroCupStages.playoff4] = CONSTANTS.euroCupStagesNames.playoff4;
        this.stages[CONSTANTS.euroCupStages.playoff2] = CONSTANTS.euroCupStagesNames.playoff2;
        this.stages[CONSTANTS.euroCupStages.final] = CONSTANTS.euroCupStagesNames.final;
    }
}